export default "__VITE_ASSET__Bja4G9AK__"